<div class="plate">
  <div class="plate-wrap">
    <div class="plate-content-mobile">
      <img alt="" src="/assets/images/landing/home/home-mobile.png">
    </div>
    <app-calculate color="white" size="big"></app-calculate>
  </div>
</div>
